import script from "./TextPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./TextPopup.vue?vue&type=script&setup=true&lang=js"

import "./TextPopup.vue?vue&type=style&index=0&id=86e06f32&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86e06f32"]])

export default __exports__